import Cookies from "js-cookie";

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: Cookies.get("sidebarStatus")
        ? !!+Cookies.get("sidebarStatus")
        : true,
      withoutAnimation: false,
    },
    size: Cookies.get("size") || "medium",
    language: Cookies.get("language") || "zh_CN",
    loginType: Cookies.get("loginType") || "vertifycode",
    applyUserInfo: {},
  },
  actions: {
    toggleSideBar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    toggleLanguage({ commit }, language) {
      console.log('toggleLanguage', language)
      commit("TOGGLE_LANGUAGE", language);
    },
    setLoginType({ commit }, type) {
      commit("SET_LOGIN_TYPE", type);
    },
  },
  mutations: {
    TOGGLE_SIDEBAR: (state) => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
      Cookies.set("sidebarStatus", state.sidebar.opened ? 1 : 0);
    },
    TOGGLE_LANGUAGE: (state, language) => {
      console.log('TOGGLE_LANGUAGE', language)
      state.language = language;
      Cookies.set("language", language);
    },
    SET_LOGIN_TYPE: (state, type) => {
      state.loginType = type;
      Cookies.set("loginType", type);
    },
    applyUserInfo: (state, applyUserInfo) => {
      state.applyUserInfo = applyUserInfo;
    },
  },
};
